import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-external-redirect',
  template: '<div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">Redirecting...</div>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ExternalRedirectComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  ngOnInit(): void {
    const url = this.route.snapshot.data['url'];
    if (url) {
      window.location.href = url;
    } else {
      // Fallback to home if no URL provided
      this.router.navigate(['/']);
    }
  }
}
